import axios from "axios";
import { BASE_API_URL } from "../utils/api-url";

export async function getIcmsStatesByCompanyId(accessToken) {
  const result = await axios.get(`${BASE_API_URL}/icms/50/1`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return result.data;
}

export async function editIcmsValues(accessToken, data) {
  const result = await axios(`${BASE_API_URL}/icms`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data,
  });

  return result.data;
}
